/**
 * Screenreaders will often fire fake mousedown events when a focusable element
 * is activated using the keyboard. We can typically distinguish between these faked
 * mousedown events and real mousedown events using the "buttons" property. While
 * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
 * the left mouse button), faked mousedowns will usually set the property value to 0.
 */
export function isFakeMousedownFromScreenReader(event) {
    return event.buttons === 0;
}

//# sourceMappingURL=fake-mousedown.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@angular/material/core/a11y/fake-mousedown.js
// module id = ./node_modules/@angular/material/core/a11y/fake-mousedown.js
// module chunks = vendor